const footerMenu = {
    ko: {
        quick: [
            { title: "개인정보처리방침", path: "/policy/privacy-policy" },
            // { title: "채용안내", path: "https://gsretail.recruiter.co.kr/career/home", blank: true },
            // { title: "입점상담", path: "/instore/partnership"},
            // { title: "멤버십/홈페이지문의", path: "gsrcu0201", pop:true, popId:"gsrcu0201", popType:'lg', popupRoot: "inquiry" },
            // { title: "입지제안", path: "gsrbr0204", pop:true, popId:"gsrbr0204", popType:'lg', popupRoot: "brand"},
            // { title: "임대상가안내", path: "/brand/development-rental-business" },
            // { title: "정도경영제보", path: "/sustainability/compliance"},
            // { title: "고객센터", path: "/inquiry/customer-center" },
            { title: "GS SHOP 시청자 관련", path: "/policy/gs-shop-viewer" },
            { title: "정도경영제보", path: "/sustainability/compliance?subTab=report#ethics-inquiry" },
            { title: "공지사항", path: "/main/notices" },
            { title: "사이트맵", path: "#none", class: "sitemap" }
        ],
        info: {
            logo: "(주)GS리테일",
            address: "서울시 강남구 논현로 508(역삼동 679번지 GS강남타워)",
            ceo: "대표이사 허서홍",
            brn: "사업자등록번호 116-81-18745",
            copyright: "Copyright ⓒGS Retail. All rights reserved."
        },
        familyOptions: [
            { value: "https://www.gsshop.com/index.gs", label: "GS SHOP" },
            { value: "https://www.mealbox25.com/", label: "밀박스25" },
            { value: "https://www.gs25.com.vn/", label: "GS25 베트남" },
            { value: "https://gs25.mn/", label: "GS25 몽골" },
            { class: "fs_line" },
            { value: "https://gsnws.co.kr/", label: "GS네트웍스" },
            { value: "https://www.gsnetvision.com/", label: "GS넷비전" },
            { value: "https://www.gstelesvc.com/", label: "GS텔레서비스" },
            { class: "fs_line" },
            { value: "https://www.gs.co.kr/ko/main", label: "(주)GS" },
            { value: "https://www.gsenergy.co.kr/", label: "GS에너지" },
            { value: "https://www.gscaltex.com/kr/", label: "GS칼텍스" },
            { value: "https://www.gseps.com/", label: "GS EPS" },
            { value: "https://www.gsenr.com/", label: "GS E&R" },
            { value: "https://www.gspnl.com/", label: "GS P&L" },
            { value: "https://www.fcseoul.com/", label: "GS스포츠" },
            { value: "https://www.gsenc.com/", label: "GS건설" },
            { value: "https://www.gsgcorp.com/kr/", label: "GS글로벌" }
        ],
        cscenter: {
            title: "※ 고객센터 대표전화",
            info: [
                { brand: "GS25", tel: "080-999-5425" },
                { brand: "GS SHOP", tel: "080-414-4545" },
                { brand: "GS THE FRESH", tel: "080-345-7700" }
            ]
        },
        skybanner: [
            { txt: "점포 창업 안내", link: "/startup/overview" },
            { txt: "상품 입점 상담", link: "/instore/partnership" },
            { txt: "고객센터", link: "/inquiry/customer-center" }
        ],
        sitemapCloseTxt: "사이트맵 닫기"
    },
    en: {
        quick: [
            /*{ title: "Privacy Policy", path: "/policy/privacy-policy" },
            { title: "Store Franchise", path: "gsrbr0204", pop: true, popId: "gsrbr0204", popType: "lg", popupRoot: "brand" },
            { title: "Partnership", path: "#none" },
            { title: "Customer Center", path: "/inquiry/customer-center" }*/
            { title: "Sitemap", path: "#none", class:'sitemap' }
        ],
        info: {
            logo: "GS Retail",
            address: "GS TOWER, 508, NONHYEON-RO, GANGNAM-GU, SEOUL, 06141, KOREA",
            ceo: "CEO Heo Seo-hong",
            brn: "116-81-18745",
            copyright: "Copyright ⓒGS Retail. All rights reserved."
        },
        familyOptions: [
            { value: "https://www.gsshop.com/index.gs", label: "GS SHOP" },
            { value: "https://www.mealbox25.com/", label: "Mealbox25" },
            { value: "https://www.gs25.com.vn/", label: "GS25 Vietnam" },
            { value: "https://gs25.mn/", label: "GS25 Mongolia" },
            { class: "fs_line" },
            { value: "https://gsnws.co.kr/", label: "GS Networks" },
            { value: "https://www.gsnetvision.com/", label: "GS Netvision" },
            { value: "https://www.gstelesvc.com/", label: "GS Teleservice" },
            { class: "fs_line" },
            { value: "https://www.gs.co.kr/ko/main", label: "GS Holdings" },
            { value: "https://www.gsenergy.co.kr/", label: "GS Energy" },
            { value: "https://www.gscaltex.com/kr/", label: "GS Caltex" },
            { value: "https://www.gseps.com/", label: "GS EPS" },
            { value: "https://www.gsenr.com/", label: "GS E&R" },
            { value: "https://www.gspnl.com/", label: "GS P&L" },
            { value: "https://www.fcseoul.com/", label: "GS Sports" },
            { value: "https://www.gsenc.com/", label: "GS E&C" },
            { value: "https://www.gsgcorp.com/kr/", label: "GS Global" }
        ],
        sitemapCloseTxt:'close'
    }
};

export default footerMenu;
